import type { DocMigration } from "../docMigration";

// This matches the ids in propLibrary.ts at the time when the migration was created.
const PropIdMigration: { [name: string]: number } = {
  Arch_ArmstrongACL_GableDetail_01: 910,
  Arch_Bracket_BKT19244_22x28_01: 29,
  Arch_Bracket_KneeBrace_16x29x6_01: 30,
  Arch_BracketAngledPost_14x18_01: 1,
  Arch_BracketCapitalCedar_18x22x8_01: 2,
  Arch_BracketCapitalCedar_24x25hx4_01: 3,
  Arch_BracketCedar_10x10x9_01: 911,
  Arch_BracketCedar_12x12x4_01: 912,
  Arch_BracketCedar_12x12x4_02: 913,
  Arch_BracketCedar_14x22x3_01: 914,
  Arch_BracketCedar_22x28_01: 915,
  Arch_BracketCedar_22x37x6_01: 916,
  Arch_BracketCedar_24x12x4_01: 917,
  Arch_BracketCedar_24x20x9_01: 918,
  Arch_BracketCedar_30x21x6_01: 919,
  Arch_BracketCedar_37x27x4_01: 920,
  Arch_BracketCedar_6x6x4_01: 921,
  Arch_BracketCedar_9x16x4_01: 922,
  Arch_BracketCedar_AngledPost_11x20x4_01: 923,
  Arch_BracketCedar_AngledPost_16x16x4_01: 924,
  Arch_BracketCedar_AngledPost_24x36x4_01: 925,
  Arch_BracketCedar_Arcd06x12_01: 4,
  Arch_BracketCedar_Block4x12x12_01: 5,
  Arch_BracketEstridge_35x8x6_01: 6,
  Arch_BracketEstridge_Tudor8x30x6_01: 7,
  Arch_BracketFlair_29_01: 8,
  Arch_BracketFypon_BKT07x12_01: 9,
  Arch_BracketFypon_BKT09x11_01: 10,
  Arch_BracketFypon_BKT10x16x4_01: 11,
  Arch_BracketFypon_BKT11x12x3_01: 12,
  Arch_BracketFypon_BKT12x12x4_01: 13,
  Arch_BracketFypon_BKT14x24_01: 14,
  Arch_BracketFypon_BKT18x18_01: 15,
  Arch_BracketFypon_BKT18X9_01: 16,
  Arch_BracketFypon_BKT20x20_01: 17,
  Arch_BracketFypon_BKT25x27_01: 18,
  Arch_BracketFypon_BKT6x24: 19,
  Arch_BracketFypon_DTLB6x6x8_01: 20,
  Arch_BracketLegacy_12_01: 21,
  Arch_BracketLegacy_14_01: 22,
  Arch_BracketLegacy_16_01: 23,
  Arch_BracketLegacy_18_01: 24,
  Arch_BracketTOB_11x15x4_01: 25,
  Arch_BracketTOB_14x16x4_01: 26,
  Arch_BracketTOB_23qx27qx4_01: 27,
  Arch_BracketWood_24x13_01: 28,
  Arch_Buff_BrickCurveColumn_01: 31,
  Arch_CircleFypon_CIR24x4F_K4TF_01: 32,
  Arch_Column_ZenAnglePair_01: 34,
  Arch_Column_ZenStraight_01: 35,
  Arch_Column120_Modern_01: 33,
  Arch_ColumnEstridge_Bracket_11x11x19_Base_01: 926,
  Arch_ColumnEstridge_Bracket_11x11x19_Cap_01: 927,
  Arch_Cupola_Jamestown_J36C_01: 36,
  Arch_Cupola_Trenton_T30C30_01: 37,
  Arch_Curved_Staircase_01: 38,
  Arch_Elliott_FakeDoorTransom_01: 39,
  Arch_Epcon_GableDetail_01: 40,
  Arch_Estridge_BrickArchedHalfwall_01: 41,
  Arch_GableDetailArc_p07o12_01: 42,
  Arch_GableDetailArc_p08o12_01: 43,
  Arch_GableDetailArc_p09o12_01: 44,
  Arch_GableDetailArc_p12o12_01: 45,
  Arch_GableDetailCraftsmanTOB_p06xo12_01: 46,
  Arch_GableDetailCraftsmanTOB_p08xo12_01: 47,
  Arch_GableDetailCraftsmanTOB_p10xo12_01: 48,
  Arch_GableDetailTOB_p06o12_01: 49,
  Arch_GableDetailTOB_p08o12_01: 50,
  Arch_GableDetailTOB_p10o12_01: 51,
  Arch_GableDetailTOB_p12o12_01: 52,
  Arch_GarageTrellis_10_01: 53,
  Arch_GarageTrellis_16_01: 54,
  Arch_GarageTrellis_17_01: 55,
  Arch_GarageTrellis_18_01: 56,
  Arch_GarageTrellis_Capital_08f11_01: 57,
  Arch_GarageTrellis_Capital_08f8_01: 58,
  Arch_GarageTrellis_Capital_09f7_01: 59,
  Arch_GarageTrellis_Capital_16f11_01: 60,
  Arch_GarageTrellis_Capital_16f8_01: 61,
  Arch_GarageTrellis_Capital_17f7_01: 62,
  Arch_KneeBraceFypon_18_01: 63,
  Arch_Layne_FakeShutter36x60_01: 64,
  Arch_Lexar_Awning_01: 65,
  Arch_Lexar_GableEndTimber_01: 66,
  Arch_LouverFypon_RLV24_6TK_01: 67,
  Arch_LouverRound_24_01: 68,
  Arch_MercerPalm_GableDetail_01: 69,
  Arch_ShutterArched_2040_01: 70,
  Arch_ShutterArched_3050_01: 71,
  Arch_ShutterArched_3060_01: 72,
  Arch_ShutterShade_01: 73,
  Arch_SoffitCorbel_08x12_01: 74,
  Arch_TriangleLouverFypon_TRLV72x36_01: 75,
  Arch_TubeBracket_01: 76,
  Arch_WindowOval_30x42_TrimK4TF_01: 77,
  Arch_WindowRound_24_01: 78,
  Arch_WindowRound_26wT6_01: 79,
  Arch_WindowWell_WET664472_01: 80,
  Arch_WindowWell_WET664472_Cap_01: 81,
  Arch_WinPlanterBox_Schell40_01: 82,
  Arch_WinPlanterBox_Schell76_01: 83,
  Bath_Floor_Drain_01: 84,
  Bath_Shower_01: 88,
  Bath_Shower_Circle_01: 89,
  Bath_Shower_Insert_36x36_01: 98,
  Bath_Shower_Insert_42x36_01: 99,
  Bath_Shower_Insert_42x42_01: 100,
  Bath_Shower_Insert_48x34_01: 101,
  Bath_Shower_Insert_48x36_01: 102,
  Bath_Shower_Insert_48x36_02: 103,
  Bath_Shower_Insert_48x42_01: 104,
  Bath_Shower_Insert_60x30_01: 105,
  Bath_Shower_Insert_60x32_01: 106,
  Bath_Shower_Insert_60x34_01: 107,
  Bath_Shower_Insert_60x36_01: 108,
  Bath_Shower_Insert_60x36_02: 109,
  Bath_Shower_Insert_60x42_01: 110,
  Bath_Shower_InsertCorner_39x39_01: 90,
  Bath_Shower_InsertFull_42x36_01: 92,
  Bath_Shower_InsertFull_48x36_01: 93,
  Bath_Shower_InsertFull_48x36_02: 94,
  Bath_Shower_InsertFull_60x36_01: 95,
  Bath_Shower_InsertFull_60x36_02: 96,
  Bath_Shower_InsertFull_Aquatic1603SG_60x35_01: 97,
  Bath_Shower_InsertFullSeat_60x36_01: 91,
  Bath_Shower_Oval_01: 111,
  Bath_Shower_Rainhead_01: 112,
  Bath_Shower_Sliding_76x36_01: 113,
  Bath_Shower_Sliding_76x48_01: 114,
  Bath_Shower_Sliding_76x60_01: 115,
  Bath_Shower_Square_01: 116,
  Bath_Shower_Valve_01: 117,
  Bath_ShowerSwing_76_x48_01: 85,
  Bath_ShowerSwing_76_x60_01: 86,
  Bath_ShowerSwing_76_x75_01: 87,
  Bath_Sink_01: 118,
  Bath_Sink_Above_01: 119,
  Bath_Sink_Oval_01: 120,
  Bath_Sink_Pedestal_01: 123,
  Bath_Sink_PedestalOval_01: 121,
  Bath_Sink_PedestalRectangle_01: 122,
  Bath_Sink_Undermount_01: 124,
  Bath_Toilet_01: 125,
  Bath_Toilet_Bidet_01: 126,
  Bath_Toilet_Washlet_01: 127,
  Bath_Towel_Bar24_01: 128,
  Bath_Towel_Hand_01: 129,
  Bath_Towel_Hook2_01: 130,
  Bath_TP_01: 131,
  Bath_Tub_CapitalGarden_60x36x19h_01: 133,
  Bath_Tub_CapitalGardenCorner_59hx59hx19h_01: 132,
  Bath_Tub_Faucet_01: 136,
  Bath_Tub_FaucetFreestand_01: 134,
  Bath_Tub_FaucetWall_01: 135,
  Bath_Tub_Freestand_60x30_01: 159,
  Bath_Tub_FreestandBasin_60x30_01: 141,
  Bath_Tub_FreestandBasin_60x34_01: 142,
  Bath_Tub_FreestandBasin_66x36_01: 143,
  Bath_Tub_FreestandBasin_66x36_02: 144,
  Bath_Tub_FreestandBasin_Boyce_56x29_01: 145,
  Bath_Tub_FreestandBasin_Boyce_61x29_01: 146,
  Bath_Tub_FreestandBasin_Boyce_65x29_01: 147,
  Bath_Tub_FreestandBasin_Boyce_70x29_01: 148,
  Bath_Tub_FreestandBasin_Sheba_72x28_01: 149,
  Bath_Tub_FreestandBasinRect_63x30_01: 137,
  Bath_Tub_FreestandBasinRect_72x36_01: 138,
  Bath_Tub_FreestandBasinRect_Avie_67x32_01: 139,
  Bath_Tub_FreestandBasinRect_Draque_66x29_01: 140,
  Bath_Tub_FreestandClaw_60x30_01: 156,
  Bath_Tub_FreestandClawBasin_60x30_01: 150,
  Bath_Tub_FreestandClawBasin_Arabella_61x30_01: 151,
  Bath_Tub_FreestandClawBasin_Arabella_72x31_01: 152,
  Bath_Tub_FreestandClawBasin_Aubretia_71x30_01: 153,
  Bath_Tub_FreestandClawBasin_Sanford_60x30_01: 154,
  Bath_Tub_FreestandClawBasin_Sanford_66x31_01: 155,
  Bath_Tub_FreestandPedestalBasin_Rosalind_63x28_01: 157,
  Bath_Tub_FreestandPedestalBasin_Rosalind_69x29_01: 158,
  Bath_Tub_Insert_60x30_01: 181,
  Bath_Tub_Insert_60x30_02: 182,
  Bath_Tub_Insert_60x32_01: 183,
  Bath_Tub_Insert_60x36_01: 184,
  Bath_Tub_InsertBasin_60x32_01: 168,
  Bath_Tub_InsertBasin_60x36_01: 169,
  Bath_Tub_InsertBasin_60x42_01: 170,
  Bath_Tub_InsertBasin_72x42_01: 171,
  Bath_Tub_InsertBasin_Montrose2_72x36_01: 172,
  Bath_Tub_InsertBasinCorner_60x60_01: 160,
  Bath_Tub_InsertBasinCorner_Cavalcade_60x60_01: 161,
  Bath_Tub_InsertBasinOval_60x40_01: 162,
  Bath_Tub_InsertBasinOval_60x42_01: 163,
  Bath_Tub_InsertBasinOval_Alydar1_60x42_01: 164,
  Bath_Tub_InsertBasinOval_Alydar1_60x42_02: 165,
  Bath_Tub_InsertBasinOval_Alydar2_72x42_01: 166,
  Bath_Tub_InsertBasinOval_Belmont2_71x41_01: 167,
  Bath_Tub_InsertShower_60x30_01: 173,
  Bath_Tub_InsertShower_60x32_01: 174,
  Bath_Tub_InsertShower_60x36_01: 175,
  Bath_Tub_InsertShower_60x42_01: 176,
  Bath_Tub_InsertShower_AkerCM_60x32_01: 177,
  Bath_Tub_InsertShower_AkerTS3660_60x36_01: 178,
  Bath_Tub_InsertShower_Aquatic2603SG_60x32_01: 179,
  Bath_Tub_InsertSoaking_72x45_01: 180,
  Bath_Vent_Circle_01: 185,
  Bath_Vent_Square_01: 186,
  Bed_Bed_Full_01: 187,
  Bed_Bed_King_01: 188,
  Bed_Bed_Queen_01: 189,
  Bed_Bed_Twin_01: 190,
  Bed_Dresser_01: 191,
  Bed_Dresser_Chest_01: 192,
  Bed_Dresser_Mirror_01: 193,
  Bed_Dresser_Nightstand_01: 194,
  BuilderDemoLots_60: 195,
  BuilderDemoLots_60_BoundLine: 196,
  BuilderDemoLots_60_BuildArea: 197,
  BuilderDemoLots_70: 198,
  BuilderDemoLots_70_BoundLine: 199,
  BuilderDemoLots_70_BuildArea: 200,
  BuilderDemoLots_80: 201,
  BuilderDemoLots_80_BoundLine: 202,
  BuilderDemoLots_80_BuildArea: 203,
  BuilderDemoLots_NeighborHouse: 204,
  Deck_Dine_4Square_01: 206,
  Deck_Dine_4SquareUmbrella_01: 205,
  Deck_Dine_6Long_01: 208,
  Deck_Dine_6LongUmbrella_01: 207,
  Deck_Dine_6PicnicUmbrella_01: 209,
  Deck_Firepit_Round_01: 210,
  Deck_Grill_Gas_01: 213,
  Deck_Grill_GasInsert_01: 212,
  Deck_Grill_GasInsert32_01: 211,
  Deck_Seat_Adirondack_01: 214,
  Deck_Seat_Bench_01: 215,
  Deck_Seat_Lounge_01: 216,
  Deck_Seat_Rocking_01: 217,
  Deck_Seat_Single_01: 218,
  Deck_Table_4Square_01: 219,
  Deck_Table_6Long_01: 220,
  Deck_Table_6Picnic_01: 221,
  Deck_Table_Side_01: 222,
  Deck_Umbrella_9ft_01: 223,
  Dining_Cabinet_Buffet_01: 224,
  Dining_Cabinet_Hutch_01: 225,
  Dining_Dine_4Long_01: 226,
  Dining_Dine_4Round_01: 227,
  Dining_Dine_4Square_01: 229,
  Dining_Dine_4SquareTall_01: 228,
  Dining_Dine_6Long_01: 231,
  Dining_Dine_6LongBench_01: 230,
  Dining_Dine_6Round_01: 232,
  Dining_Dine_8Long_01: 234,
  Dining_Dine_8Long_1: 235,
  Dining_Dine_8LongBench_01: 233,
  Dining_Seat_Dining_01: 239,
  Dining_Seat_Dining6Bench_01: 236,
  Dining_Seat_Dining8Bench_01: 237,
  Dining_Seat_DiningTall_01: 238,
  Dining_Seat_StoolBar_01: 240,
  Dining_Seat_StoolCounter_01: 241,
  Dining_Table_4Long_01: 242,
  Dining_Table_4Round_01: 243,
  Dining_Table_4Square_01: 245,
  Dining_Table_4SquareTall_01: 244,
  Dining_Table_6Long_01: 246,
  Dining_Table_6Round_01: 247,
  Dining_Table_8Long_01: 248,
  DoorExt_Doorbell_Wifi: 249,
  DoorExt_Doorbell_Wired: 250,
  DoorExt_Double24_2x4g_01: 251,
  DoorExt_Double24_2x4g_02: 252,
  DoorExt_Double30_01: 253,
  DoorExt_Double30_02: 254,
  DoorExt_Double30_Craft_01: 255,
  DoorExt_Double30_Craft_02: 256,
  DoorExt_Double30_Frames_01: 257,
  DoorExt_Double30_Frames_02: 258,
  DoorExt_Double30_HingedFixed_01: 259,
  DoorExt_Double30_HingedFixed_02: 260,
  DoorExt_Double30_NoGridHingedFixed_01: 261,
  DoorExt_Double30_NoGridHingedFixed_02: 262,
  DoorExt_Double30_Quarter_01: 263,
  DoorExt_Double30_Quarter_02: 264,
  DoorExt_Double30_SixTop_01: 265,
  DoorExt_Double30_SixTop_02: 266,
  DoorExt_Double30_Strip1_01: 267,
  DoorExt_Double30_Strip1_02: 268,
  DoorExt_Double30_Trips_01: 269,
  DoorExt_Double30_Trips_02: 270,
  DoorExt_Double36_01: 271,
  DoorExt_Double36_02: 272,
  DoorExt_Double36_Craft_01: 273,
  DoorExt_Double36_Craft_02: 274,
  DoorExt_Double36_Frames_01: 275,
  DoorExt_Double36_Frames_02: 276,
  DoorExt_Double36_HingedFixed_01: 277,
  DoorExt_Double36_HingedFixed_02: 278,
  DoorExt_Double36_NoGridHingedFixed_01: 279,
  DoorExt_Double36_NoGridHingedFixed_02: 280,
  DoorExt_Double36_Quarter_01: 281,
  DoorExt_Double36_Quarter_02: 282,
  DoorExt_Double36_SixTop_01: 283,
  DoorExt_Double36_SixTop_02: 284,
  DoorExt_Double36_SixTop_03: 285,
  DoorExt_Double36_Strip1_01: 286,
  DoorExt_Double36_Strip1_02: 287,
  DoorExt_Double36_Trips_01: 288,
  DoorExt_Double36_Trips_02: 289,
  DoorExt_Overhang108_2x4Glass_01: 290,
  DoorExt_SideLite_01: 291,
  DoorExt_SideLite_02: 292,
  DoorExt_SideLite_Craft_01: 293,
  DoorExt_SideLite_Craft_02: 294,
  DoorExt_Single30_Screen_01: 295,
  DoorExt_Single30_Screen_02: 296,
  DoorExt_Single32_01: 297,
  DoorExt_Single32_02: 298,
  DoorExt_Single32_Glass2x4_01: 299,
  DoorExt_Single32_Glass2x4_02: 300,
  DoorExt_Single32_Half1_01: 301,
  DoorExt_Single32_Half1_02: 302,
  DoorExt_Single32_HalfSolid_01: 303,
  DoorExt_Single32_HalfSolid_02: 304,
  DoorExt_Single32_Knob_01: 305,
  DoorExt_Single32_Knob_02: 306,
  DoorExt_Single32_Slab_01: 307,
  DoorExt_Single32_Slab_02: 308,
  DoorExt_Single36_01: 309,
  DoorExt_Single36_02: 310,
  DoorExt_Single36_3QuarterPlank_01: 311,
  DoorExt_Single36_3QuarterPlank_02: 312,
  DoorExt_Single36_ArcQuarter1Iron_01: 313,
  DoorExt_Single36_ArcQuarter1Iron_02: 314,
  DoorExt_Single36_Craft_01: 317,
  DoorExt_Single36_Craft_02: 318,
  DoorExt_Single36_CraftShelf_01: 315,
  DoorExt_Single36_CraftShelf_02: 316,
  DoorExt_Single36_EightLite_01: 928,
  DoorExt_Single36_EightLite_02: 929,
  DoorExt_Single36_FourLite_01: 930,
  DoorExt_Single36_FourLite_02: 931,
  DoorExt_Single36_Frames_01: 319,
  DoorExt_Single36_Frames_02: 320,
  DoorExt_Single36_Glass3Third_01: 321,
  DoorExt_Single36_Glass3Third_02: 322,
  DoorExt_Single36_Glass4_01: 327,
  DoorExt_Single36_Glass4_02: 328,
  DoorExt_Single36_Glass4Quarter_01: 325,
  DoorExt_Single36_Glass4Quarter_02: 326,
  DoorExt_Single36_Glass4QuarterH_01: 323,
  DoorExt_Single36_Glass4QuarterH_02: 324,
  DoorExt_Single36_Half1_01: 329,
  DoorExt_Single36_Half1_02: 330,
  DoorExt_Single36_HalfArcGroove_01: 331,
  DoorExt_Single36_HalfArcGroove_02: 332,
  DoorExt_Single36_HalfArcSolid_01: 932,
  DoorExt_Single36_HalfArcSolid_02: 933,
  DoorExt_Single36_NineTop_01: 333,
  DoorExt_Single36_NineTop_02: 334,
  DoorExt_Single36_Panel2Craft_01: 335,
  DoorExt_Single36_Panel2Craft_02: 336,
  DoorExt_Single36_Panel2Craft_ThreeTop_01: 337,
  DoorExt_Single36_Panel2Craft_ThreeTop_02: 338,
  DoorExt_Single36_Panel3_01: 341,
  DoorExt_Single36_Panel3_02: 342,
  DoorExt_Single36_Panel3Craft_01: 339,
  DoorExt_Single36_Panel3Craft_02: 340,
  DoorExt_Single36_Panel6_01: 343,
  DoorExt_Single36_Panel6_02: 344,
  DoorExt_Single36_Quarter_01: 353,
  DoorExt_Single36_Quarter_02: 354,
  DoorExt_Single36_Quarter1_01: 345,
  DoorExt_Single36_Quarter1_02: 346,
  DoorExt_Single36_Quarter4_01: 347,
  DoorExt_Single36_Quarter4_02: 348,
  DoorExt_Single36_QuarterSolid_01: 351,
  DoorExt_Single36_QuarterSolid_02: 352,
  DoorExt_Single36_QuarterSolid4_01: 349,
  DoorExt_Single36_QuarterSolid4_02: 350,
  DoorExt_Single36_Screen_01: 355,
  DoorExt_Single36_Screen_02: 356,
  DoorExt_Single36_SixLite_01: 934,
  DoorExt_Single36_SixLite_02: 935,
  DoorExt_Single36_SixTop_01: 357,
  DoorExt_Single36_SixTop_02: 358,
  DoorExt_Single36_Slab_01: 359,
  DoorExt_Single36_Slab_02: 360,
  DoorExt_Single36_SolidGroove_01: 936,
  DoorExt_Single36_SolidGroove_02: 937,
  DoorExt_Single36_Strip1_01: 361,
  DoorExt_Single36_Strip1_02: 362,
  DoorExt_Single36_Strip3_01: 363,
  DoorExt_Single36_Strip3_02: 364,
  DoorExt_Single36_Trips_01: 365,
  DoorExt_Single36_Trips_02: 366,
  DoorExt_Single36_TwelveTop_01: 367,
  DoorExt_Single36_TwelveTop_02: 368,
  DoorExt_Single42_ArcQuarter1Iron_01: 369,
  DoorExt_Single42_ArcQuarter1Iron_02: 370,
  DoorExt_Single42_Plank_01: 371,
  DoorExt_Single42_Plank_02: 372,
  DoorExt_Sliding108_3x6GridGlass_01: 373,
  DoorExt_Sliding108_3x6GridGlass_02: 374,
  DoorExt_Sliding108_3x6GridGlass3_01: 938,
  DoorExt_Sliding108_3x6GridGlass3_02: 939,
  DoorExt_Sliding108_Glass_01: 377,
  DoorExt_Sliding108_Glass_02: 378,
  DoorExt_Sliding108_Glass3_01: 375,
  DoorExt_Sliding108_Glass3_02: 376,
  DoorExt_Sliding108_NoGridGlass3_01: 379,
  DoorExt_Sliding108_NoGridGlass3_02: 380,
  DoorExt_Sliding120_Glass3_01: 383,
  DoorExt_Sliding120_Glass3_02: 384,
  DoorExt_Sliding120x2_Glass4_01: 381,
  DoorExt_Sliding120x2_Glass4_02: 382,
  DoorExt_Sliding144_3x6Frames_01: 385,
  DoorExt_Sliding144_3x6Frames_02: 386,
  DoorExt_Sliding144_Glass3_01: 387,
  DoorExt_Sliding144_Glass3_02: 388,
  DoorExt_Sliding168_NoGridGlass3_01: 389,
  DoorExt_Sliding168_NoGridGlass3_02: 390,
  DoorExt_Sliding180_3x6GridGlass3_01: 392,
  DoorExt_Sliding180_3x6GridGlass3_02: 393,
  DoorExt_Sliding180_Glass3_01: 394,
  DoorExt_Sliding180_Glass3_02: 395,
  DoorExt_Sliding180_NoGridGlass3_01: 396,
  DoorExt_Sliding180_NoGridGlass3_02: 397,
  DoorExt_Sliding180x108_Glass3_01: 391,
  DoorExt_Sliding48_Glass_01: 398,
  DoorExt_Sliding48_Glass_02: 399,
  DoorExt_Sliding56_Glass_01: 400,
  DoorExt_Sliding56_Glass_02: 401,
  DoorExt_Sliding60_3x6GridGlass_01: 402,
  DoorExt_Sliding60_3x6GridGlass_02: 403,
  DoorExt_Sliding60_Glass_01: 404,
  DoorExt_Sliding60_Glass_02: 405,
  DoorExt_Sliding72_3x6GridGlass_01: 406,
  DoorExt_Sliding72_3x6GridGlass_02: 407,
  DoorExt_Sliding72_Glass_01: 408,
  DoorExt_Sliding72_Glass_02: 409,
  DoorExt_Sliding90_Glass_01: 410,
  DoorExt_Sliding90_Glass_02: 411,
  DoorExt_Sliding90_Grid8Glass_01: 412,
  DoorExt_Sliding90_Grid8Glass_02: 413,
  DoorExt_Sliding92_Glass_01: 414,
  DoorExt_Sliding92_Glass_02: 415,
  DoorExt_Sliding96_Glass_01: 416,
  DoorExt_Sliding96_Glass_02: 417,
  DoorExt_Sliding96_Grid8Glass_01: 418,
  DoorExt_Sliding96_Grid8Glass_02: 419,
  DoorExt_Transom_01: 421,
  DoorExt_Transom120x4_Glass4_01: 420,
  DoorGar_D12x7_3x4Pattern_H_01: 422,
  DoorGar_D16x7_2x1_3Lite3rd_01: 431,
  DoorGar_D16x7_2x1Pattern_01: 423,
  DoorGar_D16x7_2x1Pattern_1Lite3rdCross_01: 424,
  DoorGar_D16x7_2x1SlantIn_1Lite4th_H_01: 425,
  DoorGar_D16x7_2x1SlantIn_1Panel4th_H_01: 426,
  DoorGar_D16x7_2x1SlantIn_4Lite4th_H_01: 427,
  DoorGar_D16x7_2x1SlantOut_1Lite4th_01: 940,
  DoorGar_D16x7_2x1SlantOut_1Lite4th_H_01: 428,
  DoorGar_D16x7_2x1SlantOut_1Panel4th_01: 941,
  DoorGar_D16x7_2x1SlantOut_1Panel4th_H_01: 429,
  DoorGar_D16x7_2x1X_4Lite4th_H_01: 430,
  DoorGar_D16x7_2x3Pattern_2Lite4th_01: 432,
  DoorGar_D16x7_2x3RaisedHLines_2Lite4th_01: 433,
  DoorGar_D16x7_2x3x1PatternSlantOut_3Lite4th_01: 434,
  DoorGar_D16x7_2x3x2Pattern_4Lite4th_01: 435,
  DoorGar_D16x7_2x4_01: 441,
  DoorGar_D16x7_2x4Glass_01: 436,
  DoorGar_D16x7_2x4Pattern_01: 437,
  DoorGar_D16x7_2x4Pattern_H_01: 438,
  DoorGar_D16x7_2x4RaisedHLines_01: 439,
  DoorGar_D16x7_2x4x2Pattern_H_01: 440,
  DoorGar_D16x7_4x1v3board_3Lite5th_01: 442,
  DoorGar_D16x7_4x3Pattern_2Lite4th_H_01: 443,
  DoorGar_D16x7_4x3Pattern_4Lite4th_01: 444,
  DoorGar_D16x7_4x3RaisedHLines_4Lite4th_01: 445,
  DoorGar_D16x7_4x4FlatHLines_01: 446,
  DoorGar_D16x7_4x4Pattern_01: 448,
  DoorGar_D16x7_4x4Pattern_H_01: 449,
  DoorGar_D16x7_4x4PatternHLines_01: 447,
  DoorGar_D16x7_4x4RaisedHLines_01: 450,
  DoorGar_D16x7_LexarFarmhouse_01: 451,
  DoorGar_D16x7_LexarPrairie_01: 452,
  DoorGar_D16x7_LexarSignature_01: 453,
  DoorGar_D16x7_LexarTimber_01: 454,
  DoorGar_D16x8_2x1SlantOut_1Lite4th_01: 455,
  DoorGar_D16x8_2x1SlantOut_1Lite4th_H_01: 456,
  DoorGar_D16x8_2x1SlantOut_4x2Lite4th_H_01: 457,
  DoorGar_D16x8_2x3x1PatternSlantOut_3Lite4th_01: 458,
  DoorGar_D16x8_2x3x2Pattern_2Lite4thCrossArc_01: 459,
  DoorGar_D16x8_2x3x2Pattern_3x2Lite4th_H_01: 460,
  DoorGar_D16x8_2x3x2Pattern_4Lite4th_01: 461,
  DoorGar_D16x8_2x3x2Pattern_ArcLite4th_H_01: 462,
  DoorGar_D16x8_2x4_01: 465,
  DoorGar_D16x8_2x4Pattern_2Lite5th_01: 463,
  DoorGar_D16x8_2x4RaisedHLines_2Lite5th_01: 464,
  DoorGar_D16x8_2x5Pattern_01: 466,
  DoorGar_D16x8_2x5RaisedHLines_01: 467,
  DoorGar_D16x8_4x3Pattern_4Lite4th_01: 468,
  DoorGar_D16x8_4x4Pattern_01: 469,
  DoorGar_D16x8_4x4Pattern_H_01: 470,
  DoorGar_D16x8_4x4RaisedHLines_4Lite5th_01: 471,
  DoorGar_D16x8_4x5RaisedHLines_01: 472,
  DoorGar_D16x8_LexarFarmhouse_01: 473,
  DoorGar_D16x8_LexarPrairie_01: 474,
  DoorGar_D16x8_LexarSignature_01: 475,
  DoorGar_D16x8_LexarTimber_01: 476,
  DoorGar_D18x7_2x3Pattern_2Lite4th_01: 477,
  DoorGar_D18x7_2x3RaisedHLines_2Lite4th_01: 478,
  DoorGar_D18x7_2x3x2Pattern_2Lite4th_01: 479,
  DoorGar_D18x7_2x3x2Pattern_4Lite4th_01: 480,
  DoorGar_D18x7_2x4_01: 484,
  DoorGar_D18x7_2x4Pattern_01: 481,
  DoorGar_D18x7_2x4RaisedHLines_01: 482,
  DoorGar_D18x7_2x4x2Pattern_01: 483,
  DoorGar_D18x7_4x3RaisedHLines_4Lite4th_01: 485,
  DoorGar_D18x7_4x4RaisedHLines_01: 486,
  DoorGar_D18x8_2x4Pattern_2Lite5th_01: 487,
  DoorGar_D18x8_2x4RaisedHLines_2Lite5th_01: 488,
  DoorGar_D18x8_2x4x2Pattern_2Lite5th_01: 489,
  DoorGar_D18x8_2x5Pattern_01: 490,
  DoorGar_D18x8_2x5RaisedHLines_01: 491,
  DoorGar_D18x8_2x5x2Pattern_01: 492,
  DoorGar_D18x8_4x4RaisedHLines_4Lite5th_01: 493,
  DoorGar_D18x8_4x5RaisedHLines_01: 494,
  DoorGar_D20x8_2x1Pattern_1Lite3rdCross_01: 495,
  DoorGar_D20X8_4x5Glass_01: 496,
  DoorGar_S10x7_LexarFarmhouse_01: 497,
  DoorGar_S10x7_LexarPrairie_01: 498,
  DoorGar_S10x7_LexarSignature_01: 499,
  DoorGar_S10x7_LexarTimber_01: 500,
  DoorGar_S10x8_2x1Pattern_1Lite3rdCross_01: 501,
  DoorGar_S10X8_4x5Glass_01: 502,
  DoorGar_S10x8_LexarFarmhouse_01: 503,
  DoorGar_S10x8_LexarPrairie_01: 504,
  DoorGar_S10x8_LexarSignature_01: 505,
  DoorGar_S10x8_LexarTimber_01: 506,
  DoorGar_S8x7_2x1_3Lite3rd_01: 515,
  DoorGar_S8x7_2x1Pattern_01: 507,
  DoorGar_S8x7_2x1Pattern_1Lite3rdCross_01: 508,
  DoorGar_S8x7_2x1SlantIn_1Lite4th_H_01: 509,
  DoorGar_S8x7_2x1SlantIn_1Panel4th_H_01: 510,
  DoorGar_S8x7_2x1SlantIn_4Lite4th_H_01: 511,
  DoorGar_S8x7_2x1SlantOut_1Lite4th_H_01: 512,
  DoorGar_S8x7_2x1SlantOut_1Panel4th_H_01: 513,
  DoorGar_S8x7_2x1X_4Lite4th_H_01: 514,
  DoorGar_S8x7_2x3Pattern_2Lite4th_01: 516,
  DoorGar_S8x7_2x3RaisedHLines_2Lite4th_01: 517,
  DoorGar_S8x7_2x3x1PatternSlantOut_3Lite4th_01: 518,
  DoorGar_S8x7_2x3x2Pattern_4Lite4th_01: 519,
  DoorGar_S8x7_2x4_01: 526,
  DoorGar_S8x7_2x4Glass_01: 520,
  DoorGar_S8x7_2x4Pattern_01: 521,
  DoorGar_S8x7_2x4Pattern_2Lite5th_01: 522,
  DoorGar_S8x7_2x4Pattern_H_01: 523,
  DoorGar_S8x7_2x4RaisedHLines_01: 524,
  DoorGar_S8x7_2x4x2Pattern_H_01: 525,
  DoorGar_S8x7_2x5Pattern_01: 527,
  DoorGar_S8x7_4x1v3board_3Lite5th_01: 528,
  DoorGar_S8x7_4x3Pattern_2Lite4th_H_01: 529,
  DoorGar_S8x7_4x3Pattern_4Lite4th_01: 530,
  DoorGar_S8x7_4x3RaisedHLines_4Lite4th_01: 531,
  DoorGar_S8x7_4x4Pattern_01: 533,
  DoorGar_S8x7_4x4Pattern_H_01: 534,
  DoorGar_S8x7_4x4PatternHLines_01: 532,
  DoorGar_S8x7_4x4RaisedHLines_01: 535,
  DoorGar_S8x7_LexarFarmhouse_01: 536,
  DoorGar_S8x7_LexarPrairie_01: 537,
  DoorGar_S8x7_LexarSignature_01: 538,
  DoorGar_S8x7_LexarTimber_01: 539,
  DoorGar_S8x8_2x1SlantOut_1Lite4th_01: 540,
  DoorGar_S8x8_2x1SlantOut_1Lite4th_H_01: 541,
  DoorGar_S8x8_2x1SlantOut_4x2Lite4th_H_01: 542,
  DoorGar_S8x8_2x3x1PatternSlantOut_3Lite4th_01: 543,
  DoorGar_S8x8_2x3x2Pattern_2Lite4thCrossArc_01: 544,
  DoorGar_S8x8_2x3x2Pattern_3x2Lite4th_H_01: 545,
  DoorGar_S8x8_2x3x2Pattern_4Lite4th_01: 546,
  DoorGar_S8x8_2x3x2Pattern_ArcLite4th_H_01: 547,
  DoorGar_S8x8_2x4_01: 550,
  DoorGar_S8x8_2x4Pattern_2Lite5th_01: 548,
  DoorGar_S8x8_2x4RaisedHLines_2Lite5th_01: 549,
  DoorGar_S8x8_2x5Pattern_01: 551,
  DoorGar_S8x8_2x5RaisedHLines_01: 552,
  DoorGar_S8x8_4x3Pattern_4Lite4th_01: 553,
  DoorGar_S8x8_4x4Pattern_01: 554,
  DoorGar_S8x8_4x4Pattern_H_01: 555,
  DoorGar_S8x8_4x4RaisedHLines_4Lite5th_01: 556,
  DoorGar_S8x8_4x5RaisedHLines_01: 557,
  DoorGar_S8x8_LexarFarmhouse_01: 558,
  DoorGar_S8x8_LexarPrairie_01: 559,
  DoorGar_S8x8_LexarSignature_01: 560,
  DoorGar_S8x8_LexarTimber_01: 561,
  DoorGar_S9x7_2x1_3Lite3rd_01: 566,
  DoorGar_S9x7_2x1Pattern_01: 562,
  DoorGar_S9x7_2x1Pattern_1Lite3rdCross_01: 563,
  DoorGar_S9x7_2x1SlantIn_4Lite4th_H_01: 564,
  DoorGar_S9x7_2x1X_4Lite4th_H_01: 565,
  DoorGar_S9x7_2x3Pattern_2Lite4th_01: 567,
  DoorGar_S9x7_2x3RaisedHLines_2Lite4th_01: 568,
  DoorGar_S9x7_2x3x2Pattern_4Lite4th_01: 569,
  DoorGar_S9x7_2x4_01: 575,
  DoorGar_S9x7_2x4Glass_01: 570,
  DoorGar_S9x7_2x4Pattern_01: 571,
  DoorGar_S9x7_2x4Pattern_H_01: 572,
  DoorGar_S9x7_2x4RaisedHLines_01: 573,
  DoorGar_S9x7_2x4x2Pattern_H_01: 574,
  DoorGar_S9x7_4x1v3board_3Lite5th_01: 576,
  DoorGar_S9x7_4x3Pattern_2Lite4th_H_01: 577,
  DoorGar_S9x7_4x3Pattern_4Lite4th_01: 578,
  DoorGar_S9x7_4x3RaisedHLines_4lite4th_01: 579,
  DoorGar_S9x7_4x4FlatHLines_01: 580,
  DoorGar_S9x7_4x4Pattern_01: 582,
  DoorGar_S9x7_4x4Pattern_H_01: 583,
  DoorGar_S9x7_4x4PatternHLines_01: 581,
  DoorGar_S9x7_4x4RaisedHLines_01: 584,
  DoorGar_S9x8_2x3Pattern_2Lite4th_01: 585,
  DoorGar_S9x8_2x4Pattern_01: 586,
  DoorGar_S9x8_2x4RaisedHLines_2Lite5th_01: 587,
  DoorGar_S9x8_2x4x2Pattern_2Lite5th_01: 588,
  DoorGar_S9x8_2x5RaisedHLines_01: 589,
  DoorGar_S9x8_2x5x2Pattern_01: 590,
  DoorGar_S9x8_4x4RaisedHLines_4Lite5th_01: 591,
  DoorGar_S9x8_4x5RaisedHLines_01: 592,
  DoorInt_Cellar24_Glass3_01: 593,
  DoorInt_Cellar24_Glass3_02: 594,
  DoorInt_Double18_01: 595,
  DoorInt_Double18_02: 596,
  DoorInt_Double18_Bypass_01: 597,
  DoorInt_Double18_Bypass_02: 598,
  DoorInt_Double18_Closet_01: 599,
  DoorInt_Double18_Closet_02: 600,
  DoorInt_Double20_Closet_01: 601,
  DoorInt_Double20_Closet_02: 602,
  DoorInt_Double24_01: 603,
  DoorInt_Double24_02: 604,
  DoorInt_Double24_Bypass_01: 605,
  DoorInt_Double24_Bypass_02: 606,
  DoorInt_Double24_Closet_01: 607,
  DoorInt_Double24_Closet_02: 608,
  DoorInt_Double24_French3_01: 609,
  DoorInt_Double24_French3_02: 610,
  DoorInt_Double28_01: 611,
  DoorInt_Double28_02: 612,
  DoorInt_Double28_BiFold_01: 613,
  DoorInt_Double28_BiFold_02: 614,
  DoorInt_Double28_Bypass_01: 615,
  DoorInt_Double28_Bypass_02: 616,
  DoorInt_Double28_Closet_01: 617,
  DoorInt_Double28_Closet_02: 618,
  DoorInt_Double30_01: 619,
  DoorInt_Double30_02: 620,
  DoorInt_Double30_Barn_01: 621,
  DoorInt_Double30_Barn_02: 622,
  DoorInt_Double30_Bypass_01: 623,
  DoorInt_Double30_Bypass_02: 624,
  DoorInt_Double30_Closet_01: 625,
  DoorInt_Double30_Closet_02: 626,
  DoorInt_Double30_French_01: 629,
  DoorInt_Double30_French_02: 630,
  DoorInt_Double30_French_Transom_01: 631,
  DoorInt_Double30_French_Transom_02: 632,
  DoorInt_Double30_French3_01: 627,
  DoorInt_Double30_French3_02: 628,
  DoorInt_Double32_01: 633,
  DoorInt_Double32_02: 634,
  DoorInt_Double32_Bypass_01: 635,
  DoorInt_Double32_Bypass_02: 636,
  DoorInt_Double32_Closet_01: 637,
  DoorInt_Double32_Closet_02: 638,
  DoorInt_Double36_01: 639,
  DoorInt_Double36_02: 640,
  DoorInt_Double36_Barn_01: 641,
  DoorInt_Double36_Barn_02: 642,
  DoorInt_Double36_BiFold_01: 643,
  DoorInt_Double36_BiFold_02: 644,
  DoorInt_Double36_Bypass_01: 645,
  DoorInt_Double36_Bypass_02: 646,
  DoorInt_Double36_Closet_01: 647,
  DoorInt_Double36_Closet_02: 648,
  DoorInt_Double36_French_Transom_01: 649,
  DoorInt_Double36_French_Transom_02: 650,
  DoorInt_Double38_01: 651,
  DoorInt_Double38_02: 652,
  DoorInt_Double38_Bypass_01: 653,
  DoorInt_Double38_Bypass_02: 654,
  DoorInt_Double38_Closet_01: 655,
  DoorInt_Double38_Closet_02: 656,
  DoorInt_Double48_BiFold_01: 657,
  DoorInt_Double48_BiFold_02: 658,
  DoorInt_Single18_01: 659,
  DoorInt_Single18_02: 660,
  DoorInt_Single18_Closet_01: 661,
  DoorInt_Single18_Closet_02: 662,
  DoorInt_Single18_Pocket_01: 663,
  DoorInt_Single18_Pocket_02: 664,
  DoorInt_Single20_Closet_01: 665,
  DoorInt_Single20_Closet_02: 666,
  DoorInt_Single24_01: 667,
  DoorInt_Single24_02: 668,
  DoorInt_Single24_Closet_01: 669,
  DoorInt_Single24_Closet_02: 670,
  DoorInt_Single24_Pocket_01: 671,
  DoorInt_Single24_Pocket_02: 672,
  DoorInt_Single28_01: 673,
  DoorInt_Single28_02: 674,
  DoorInt_Single28_BiFold_01: 675,
  DoorInt_Single28_BiFold_02: 676,
  DoorInt_Single28_Closet_01: 677,
  DoorInt_Single28_Closet_02: 678,
  DoorInt_Single28_Pocket_01: 679,
  DoorInt_Single28_Pocket_02: 680,
  DoorInt_Single30_01: 681,
  DoorInt_Single30_02: 682,
  DoorInt_Single30_Closet_01: 683,
  DoorInt_Single30_Closet_02: 684,
  DoorInt_Single30_Pocket_01: 685,
  DoorInt_Single30_Pocket_02: 686,
  DoorInt_Single32_01: 687,
  DoorInt_Single32_02: 688,
  DoorInt_Single32_Closet_01: 689,
  DoorInt_Single32_Closet_02: 690,
  DoorInt_Single32_Louvred_01: 691,
  DoorInt_Single32_Louvred_02: 692,
  DoorInt_Single32_Pocket_01: 693,
  DoorInt_Single32_Pocket_02: 694,
  DoorInt_Single34_01: 695,
  DoorInt_Single34_02: 696,
  DoorInt_Single36_01: 697,
  DoorInt_Single36_02: 698,
  DoorInt_Single36_Barn_01: 699,
  DoorInt_Single36_Barn_02: 700,
  DoorInt_Single36_BiFold_01: 701,
  DoorInt_Single36_BiFold_02: 702,
  DoorInt_Single36_Closet_01: 703,
  DoorInt_Single36_Closet_02: 704,
  DoorInt_Single36_Pocket_01: 705,
  DoorInt_Single36_Pocket_02: 706,
  DoorInt_Single36_QuarterRound_01: 707,
  DoorInt_Single36_QuarterRound_02: 708,
  DoorInt_Single38_01: 709,
  DoorInt_Single38_02: 710,
  DoorInt_Single38_Closet_01: 711,
  DoorInt_Single38_Closet_02: 712,
  DoorInt_Single38_Pocket_01: 713,
  DoorInt_Single38_Pocket_02: 714,
  DoorInt_Single48_BiFold_01: 715,
  DoorInt_Single48_BiFold_02: 716,
  Garage_Car_Sedan_01: 717,
  Garage_SUV_Crossover_01: 718,
  Garage_Truck_Pickup_01: 719,
  General_AddressPlaque_14x07_01: 720,
  General_Fireplace_DoubleSided36_01: 721,
  General_Fireplace_FullFrameMantle_01: 722,
  General_Fireplace_Heatilator_VillaGas36_01: 723,
  General_Fireplace_IconI60_01: 724,
  General_Fireplace_InsertLogs_01: 725,
  General_Fireplace_InsertModern_01: 726,
  General_Fireplace_NBV3630_01: 727,
  General_Fireplace_Simplifire_ALLP50_01: 731,
  General_Fireplace_Simplifire38_01: 728,
  General_Fireplace_Simplifire58_01: 729,
  General_Fireplace_Simplifire60_01: 730,
  Kitchen_CabinetCorner42_wDoubleSink_01: 732,
  Kitchen_Cooktop30_G01: 733,
  Kitchen_Cooktop36_E01: 734,
  Kitchen_Cooktop36_G01: 735,
  Kitchen_Dishwasher_01: 737,
  Kitchen_Dishwasher24_01: 736,
  Kitchen_Fridge29_Bottom_01: 738,
  Kitchen_Fridge29_Top_01: 739,
  Kitchen_Fridge35_French_01: 740,
  Kitchen_Fridge35_Side_01: 741,
  Kitchen_Fridge36_Side_01: 742,
  Kitchen_Fridge48_Side_MonogramZISS480DN_01: 743,
  Kitchen_Fridge70_Double_01: 744,
  Kitchen_FridgeMini24_2Drawer_01: 745,
  Kitchen_FridgeMini24_Single_01: 746,
  Kitchen_FridgeMini24_Wine_01: 747,
  Kitchen_Hood30_01: 748,
  Kitchen_Hood36_01: 749,
  Kitchen_HoodCanopy30_01: 750,
  Kitchen_HoodCanopy36_01: 751,
  Kitchen_HoodFlat36_01: 752,
  Kitchen_IceMaker18_01: 753,
  Kitchen_Keg_TapTower1_01: 754,
  Kitchen_Microwave30_OverRange_01: 755,
  Kitchen_Microwave30_Wall_01: 756,
  Kitchen_Microwave36_Wall_01: 757,
  Kitchen_Oven20_Range_E01: 758,
  Kitchen_Oven30_Range_G01: 761,
  Kitchen_Oven30_Wall_01: 763,
  Kitchen_Oven30_WallConvection_01: 762,
  Kitchen_Oven30Microwave_Wall_01: 759,
  Kitchen_Oven30Oven_Wall_01: 760,
  Kitchen_Oven36_Range_E01: 764,
  Kitchen_Oven36_Range_G01: 765,
  Kitchen_PotFiller_WallMount_01: 766,
  Kitchen_Sink15_Bar_01: 767,
  Kitchen_Sink17_Single_01: 768,
  Kitchen_Sink30_Single_01: 769,
  Kitchen_Sink36_Double_01: 771,
  Kitchen_Sink36_DoubleOffset_01: 770,
  Kitchen_Sink36_SingleApron_01: 772,
  Kitchen_Sink36_SingleDrain_01: 773,
  Kitchen_Sink36_SingleWide_01: 774,
  Kitchen_Sink42_Double_01: 775,
  Kitchen_Sink48_Double_01: 776,
  Kitchen_Trash15_01: 777,
  Laundry_Dryer_Front_01: 780,
  Laundry_Dryer_FrontLoad_01: 779,
  Laundry_Dryer_Pedestal_01: 781,
  Laundry_DryerWasher_Stack_01: 778,
  Laundry_Pedestal_01: 782,
  Laundry_Sink_Utility_01: 783,
  Laundry_Washer_FrontLoad_01: 784,
  Laundry_Washer_Pedestal_01: 785,
  Laundry_Washer_Top_01: 786,
  Lights_ExteriorCeiling_Elias_01: 788,
  Lights_ExteriorCeiling_EliasFlush_01: 787,
  Lights_ExteriorCeiling_Forestdale_01: 789,
  Lights_ExteriorCeiling_Landen_01: 790,
  Lights_ExteriorCeiling_Manningham_01: 791,
  Lights_ExteriorCeiling_Wiscombe_01: 792,
  Lights_ExteriorWall_Argyle_01: 793,
  Lights_ExteriorWall_Elias_01: 794,
  Lights_ExteriorWall_Farmhouse_01: 795,
  Lights_ExteriorWall_Forestdale_01: 796,
  Lights_ExteriorWall_Jamestowne17_01: 797,
  Lights_ExteriorWall_Landen_01: 798,
  Lights_ExteriorWall_LanternFixed_01: 799,
  Lights_ExteriorWall_LanternShort_01: 800,
  Lights_ExteriorWall_LanternStanding_01: 801,
  Lights_ExteriorWall_LanternTall_01: 802,
  Lights_ExteriorWall_Manningham_01: 803,
  Lights_ExteriorWall_Prairie_01: 804,
  Lights_ExteriorWall_SaucerBarn_01: 805,
  Lights_ExteriorWall_Signature_01: 806,
  Lights_ExteriorWall_Timber_01: 807,
  Lights_ExteriorWall_Wiscombe_01: 808,
  Lights_Interior_Bracket1D_01: 818,
  Lights_Interior_Bracket2D_01: 819,
  Lights_Interior_Bracket3D_01: 820,
  Lights_Interior_Bracket4D_01: 821,
  Lights_Interior_Bracket5D_01: 822,
  Lights_InteriorCeiling_44fan_01: 809,
  Lights_InteriorCeiling_52fan5_01: 810,
  Lights_InteriorCeiling_AldenLinear_01: 811,
  Lights_InteriorCeiling_BasicsFan_01: 812,
  Lights_InteriorCeiling_FlushMount_01: 813,
  Lights_InteriorCeiling_Maclain_01: 814,
  Lights_InteriorCeiling_Pendant_01: 815,
  Lights_InteriorWall_FlushMount_01: 816,
  Lights_InteriorWall_Kichler_01: 817,
  Living_Cabinet_TV_01: 823,
  Living_Seat_ArmChair_01: 825,
  Living_Seat_ArmChairChaise_01: 824,
  Living_Seat_LoveSeat_01: 826,
  Living_Seat_Sofa3ChaiseL_01: 827,
  Living_Seat_Sofa3Straight_01: 828,
  Living_Table_Coffee_01: 829,
  Living_Table_EndRectangle_01: 830,
  Living_Table_EndSquare_01: 831,
  Living_TV_65_01: 833,
  Living_TV_65Wall_01: 832,
  Lot_GenericTestTree_Center: 834,
  Lot_TestBush_Single_01: 835,
  Office_Bookcase_2Single_01: 836,
  Office_Bookcase_3Single_01: 837,
  Office_Bookcase_4Single_01: 838,
  Office_Bookcase_5Single_01: 839,
  Office_Bookcase_6Single_01: 840,
  Office_Chair_Roll_01: 841,
  Office_Desk_1Cabinet_01: 844,
  Office_Desk_2Cabinet_01: 845,
  Office_DeskSet_1Cabinet_01: 842,
  Office_DeskSet_2Cabinet_01: 843,
  pCube1: 846,
  Plant_Tree_BirchRiver_01: 847,
  Plant_Tree_BirchRiver_02: 848,
  Plant_Tree_CypressLeyland_01: 849,
  Plant_Tree_CypressLeyland_02: 850,
  Plant_Tree_MagnoliaFull_01: 851,
  Plant_Tree_MagnoliaFull_02: 852,
  Plant_Tree_MapleRed_01: 853,
  Plant_Tree_MapleRed_02: 854,
  Plant_Tree_OakWhite_01: 855,
  Plant_Tree_OakWhite_02: 856,
  Plant_Tree_PineLoblolly_01: 857,
  Plant_Tree_PineLoblolly_02: 858,
  Plant_Tree_PoplarYellow_01: 859,
  Plant_Tree_PoplarYellow_02: 860,
  Plant_Tree_SweetGum_01: 861,
  Plant_Tree_SweetGum_02: 862,
  TestHouseModel_Lido_01: 863,
  Utility_AC_2halfTon_01: 865,
  Utility_AC_3halfTon_01: 866,
  Utility_AC_HeatPump_01: 867,
  Utility_ACWall_DuctlessMiniSplit_36x12_01: 864,
  Utility_AtticLadder_22Hx54_01: 868,
  Utility_AtticLadder_25Hx54_01: 869,
  Utility_Breaker_Panel_01: 870,
  Utility_CoaxialEthernet01_01: 871,
  Utility_Detector_Smoke_01: 872,
  Utility_Furnace_Hung_01: 873,
  Utility_GarageDoor_Opener_01: 874,
  Utility_Heater_GMSS960603BN_01: 876,
  Utility_Heater_GMSS960804CN_01: 877,
  Utility_HeaterWall_ElectricRecessed_01: 875,
  Utility_Meter_01: 878,
  Utility_Outlet01_01: 879,
  Utility_Outlet01_Cover_01: 880,
  Utility_Outlet01_FlipCover_01: 881,
  Utility_Outlet02_01: 882,
  Utility_Outlet02_FlipCover_01: 883,
  Utility_Outlet03_01: 884,
  Utility_Outlet03_FlipCover_01: 885,
  Utility_Outlet04_01: 886,
  Utility_Outlet05_01: 887,
  Utility_OutletGFCI01_01: 888,
  Utility_OutletGFCI02_01: 889,
  Utility_Spigot_01: 890,
  Utility_Switch01Outlet01_01: 891,
  Utility_Switch01OutletGFCI01_01: 892,
  Utility_SwitchHalfOutlet01_01: 893,
  Utility_SwitchRocker01_01: 894,
  Utility_SwitchRocker02_01: 895,
  Utility_SwitchRocker03_01: 896,
  Utility_SwitchRocker04_01: 897,
  Utility_SwitchRocker05_01: 898,
  Utility_Thermostat_Honeywell_01: 899,
  Utility_Thermostat_Nest_01: 900,
  Utility_Thermostat_Touch_01: 901,
  Utility_WaterHeater_50g_01: 905,
  Utility_WaterHeater_50gTall_01: 904,
  Utility_WaterHeaterTankless_RTGHxxDVLN_01: 902,
  Utility_WaterHeaterTankless_RTGK160N1_01: 903,
  Utility_WaterSoftener_FrontToBack_01: 942,
  Utility_WaterSoftener_SideBySide_01: 943,
  WoodlawnProp_APP_01: 906,
  WoodlawnProp_Proxy_01: 907,
  X_CameraProp: 908,
  X_Rounded_Cube: 909,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_218: DocMigration = {
  maxSchemaVersion: "0.0.218",
  description: "Change prop references to use ID numbers",
  apply(json: any) {
    const settingsArray: any[] = Object.values(json.settings);
    for (const settings of settingsArray) {
      if (settings.type === "EXTERIOR_PROP_SETTINGS" || settings.type === "INTERIOR_PROP_SETTINGS") {
        migratePropTable(settings);
      }
    }

    return json;
  },
};

function migratePropTable(propSettings: any) {
  if (propSettings === undefined) {
    return;
  }
  const propTypes = propSettings.propTypes;
  if (propTypes === undefined) {
    return;
  }
  for (const key of Object.keys(propTypes)) {
    if (propTypes[key].propId !== undefined) {
      propTypes[key].propAssetId = PropIdMigration[propTypes[key].propId];
      delete propTypes[key].propId;
    }
  }
}

export default migration_0_0_218;
